import { Input, InputLeftElement, InputProps, InputRightElement } from '@chakra-ui/input';
import { InputGroup } from '@chakra-ui/react';
import { Icon, TIconName } from 'components';
import React, { ComponentProps, memo } from 'react';

import { Label } from '../';
import * as Styles from './styles';

type TIconProp = ComponentProps<typeof Icon> | TIconName;

interface IProps {
  inputRef?: React.RefObject<HTMLInputElement>;
  label?: string;
  leftIcon?: TIconProp;
  rightIcon?: TIconProp;
  disabled?: boolean;
  tip?: string | JSX.Element;
  labelColor?: string;
  isDateInput?: boolean;
}

type TTextFieldProps = InputProps & IProps;

const TextFieldComponent: React.FC<TTextFieldProps> = ({
  inputRef,
  leftIcon,
  rightIcon,
  tip,
  labelColor,
  ...props
}) => {
  const handleClick = () => {
    if (inputRef?.current === undefined || inputRef?.current === null) {
      return '';
    } else {
      inputRef.current.focus();
    }
  };

  return (
    <Styles.Container>
      {props.label && (
        <Label color={labelColor} tip={tip} htmlFor={props.label}>
          {props.label}
        </Label>
      )}

      <InputGroup>
        {leftIcon && (
          <InputLeftElement height={'100%'}>
            <Icon
              onClick={handleClick}
              {...(typeof leftIcon === 'string' ? { name: leftIcon } : leftIcon)}
            />
          </InputLeftElement>
        )}
        <Input ref={inputRef} {...props} />

        {rightIcon && (
          <InputRightElement height={'100%'}>
            <Icon
              id={props.label}
              {...(typeof rightIcon === 'string' ? { name: rightIcon } : rightIcon)}
            />
          </InputRightElement>
        )}
      </InputGroup>
    </Styles.Container>
  );
};

export const TextField = memo(TextFieldComponent);
